import { render, staticRenderFns } from "./Mails.vue?vue&type=template&id=f75d6d96&scoped=true"
import script from "./Mails.vue?vue&type=script&lang=js"
export * from "./Mails.vue?vue&type=script&lang=js"
import style0 from "./Mails.vue?vue&type=style&index=0&id=f75d6d96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_cache-loader@4.1.0_css-loader@3.6.0_prettier@3.1.1_vue-template-compiler@2.7.16_webpack@4.47.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f75d6d96",
  null
  
)

export default component.exports